@if (isMasterProduct$ | async) {
<span class="product-variation read-only">
  {{ 'product.variations.text' | translate : { '0': variationCount$ | async } }}
</span>
} @if (isVariationProduct$ | async) { @if ((visible$ | async) && showVisible()) {
<div class="product-variation-container">
  @if (readOnly$ | async) {
  <ish-product-variation-display />
  } @else {
  <ish-product-variation-select />
  }
</div>
} }
